var ReactDOM = require('react-dom');
var appTypes = require('../types/appTypes');
var _ = require('underscore');

var CLOSE_POPUP_EVENT = 'onClosePopup';
var OPEN_POPUP_EVENT = 'onOpenPopup';

var popupStack = {};

//todo:mxj 弹出与关闭的动画之后由这个函数中来解析。因为这些参数属于组件本身的属性
function RegisterPopup(popup, manager) {
  this.manager = manager;
  var self = this;
  //todo:mxj 这里未使用的几个变量，函数保留，为之后需要改进时所要使用的
  var contentOpenBeforeCSS;
  var contentOpenAnimateParams;
  var contentCloseAnimateParams;
  var bgOpenAnimateParams;
  var bgCloseAnimateParams;
  var bgAnimateOption;
  var contentAnimateOption;
  var showBackground;
  var props = popup.props;
  var contentProps = props.items[1];
  var openFinish;
  var closeFinish;

  this.dom = ReactDOM.findDOMNode(popup);
  this.content = $(ReactDOM.findDOMNode(popup.refs.content));
  this.background = $(ReactDOM.findDOMNode(popup.refs.background));
  /*
   function doInitBgAnimate(){
   if(props.isBackgroundFade) {
   bgOpenAnimateParams = {opacity: 1};
   bgCloseAnimateParams = {opacity: 0};
   }else{
   bgOpenAnimateParams = {visibility:'visible'};
   bgCloseAnimateParams = {visibility:'hidden'};
   }
   }

   function doFadeIn(){
   contentOpenBeforeCSS = {opacity : 0};
   contentOpenAnimateParams = {opacity : 1};
   contentCloseAnimateParams = {opacity : 0};
   }

   function doMoveToUp(){
   contentOpenBeforeCSS = {top : props.pageSize.height};
   contentOpenAnimateParams = {y : props.pageSize.height - contentProps.h};
   contentCloseAnimateParams = {y: contentOpenBeforeCSS.top};
   }

   function doMoveToDown(){
   contentOpenBeforeCSS = {top : 0 - contentProps.h};
   contentOpenAnimateParams = {y : 0};
   contentCloseAnimateParams = {y: contentOpenBeforeCSS.top};
   }

   function  doMoveToLeft(){
   contentOpenBeforeCSS = {left : props.pageSize.width};
   contentOpenAnimateParams = {x : contentOpenBeforeCSS.left - contentProps.w};
   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left};
   }

   function doMoveToRight(){
   contentOpenBeforeCSS = {left : 0-contentProps.w};
   contentOpenAnimateParams = {x : 0};
   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left};
   }

   function doZoomIn(){
   contentOpenBeforeCSS = {left : props.pageSize.width/2,top:props.pageSize.height/2,scale:0};
   contentOpenAnimateParams = {x : (props.pageSize.width - contentProps.w)/2,y:(props.pageSize.height - contentProps.h)/2,scale:1};
   contentCloseAnimateParams = {x: contentOpenBeforeCSS.left,y:contentOpenBeforeCSS.top,scale:0};
   }

   function doExpandToUp(){
   contentOpenBeforeCSS = {top:props.pageSize.height,height : 0};
   contentOpenAnimateParams = {y : props.pageSize.height - contentProps.h,height:contentProps.h};
   contentCloseAnimateParams = {y:props.pageSize.height,height:0};
   }

   function doExpandToDown(){
   contentOpenBeforeCSS = {top:0,height:0};
   contentOpenAnimateParams = {height:contentProps.h};
   contentCloseAnimateParams = {height:0};
   }

   function doExpandToLeft(){
   contentOpenBeforeCSS = {left:props.pageSize.width,width:0};
   contentOpenAnimateParams = {x:props.pageSize.width - contentProps.w,width:contentProps.w};
   contentCloseAnimateParams = {x : props.pageSize.width,width:0};
   }

   function doExpandToRight(){
   contentOpenBeforeCSS = {left:0,width:0};
   contentOpenAnimateParams = {width:contentProps.w};
   contentCloseAnimateParams = {width:0};
   }

   //isBackgroundFade="False"
   //aniType_Mobile="aniFade"
   //aniType="dnNone"
   //closeByClickMode="cmClickOutSizeArea"
   //closeByKeyModes="[kmEsc,kmEnter]"
   //isShowBackground="False"
   //delayBeforePopup="0"
   //aniDuration="200"
   //positionPolicy="ppScreenFix"
   //positionMargin="0"
   //positionScreenMode="psCenter"
   //positionComMode="pcBottom"


   function doInitAnimateOptions(){

   }

   function doShowOrigPoint(){
   contentOpenBeforeCSS = {visibility : 'visible'};
   }

   function doLocationToScreenTop(margin){
   contentOpenBeforeCSS = {top : margin};
   }

   function doLocationToScreenBottom(margin){
   contentOpenBeforeCSS = {top : props.pageSize.height - contentProps.h - margin};
   }

   function doLocationToScreenCenter(){
   contentOpenBeforeCSS = {top : (props.pageSize.height - contentProps.h)/2};
   }

   function doLocationToSourceComTop(margin){
   contentOpenBeforeCSS = {top : props.sourceBounds.top - contentProps.h - margin};
   }

   function doLocationToSourceComBottom(margin){
   contentOpenBeforeCSS = {top : props.sourceBounds.bottom - margin};
   }

   function doLocationToSourceComLeft(margin){
   contentOpenBeforeCSS = {left : props.sourceBounds.left - contentProps.w - margin};
   }

   function doLocationToSourceComRight(margin){
   contentOpenBeforeCSS = {left : props.sourceBounds.roght + margin};
   }

   function doShowInPoint(){}

   function doLocationToScreen(){
   var mode = props.positionScreenMode;
   var margin = parseInt(props.positionMargin,10);
   switch (mode){
   case appTypes.PositionScreenMode.TOP:
   doLocationToScreenTop(margin);
   break;
   case appTypes.PositionScreenMode.CENTER:
   doLocationToScreenCenter();
   break;
   case appTypes.PositionScreenMode.BOTTOM:
   doLocationToScreenBottom(margin);
   break;
   }
   }

   function doLocationToSourceCom(){
   var mode = props.positionComMode;
   var margin = parseInt(props.positionMargin,10);
   switch(mode){
   case appTypes.PositionComMode.TOP:
   doLocationToSourceComTop(margin);
   break;
   case appTypes.PositionComMode.BOTTOM:
   doLocationToSourceComBottom(margin);
   break;
   case appTypes.PositionComMode.LEFT:
   doLocationToSourceComLeft(margin);
   break;
   case appTypes.PositionComMode.RIGHT:
   doLocationToSourceComRight(margin);
   break;
   }
   }

   function doLocationFree(){
   var platform = props.platform;
   var aniType;
   if (platform === appTypes.AppPlatformType.MOBILE || platform === appTypes.AppPlatformType.PAD) {
   aniType = props.aniType_Mobile;
   } else if (platform !== appTypes.AppPlatformType.BLANK) {
   aniType = props.aniType;
   }
   if(!_.isUndefined(props.drawerSlideDirection)){
   if(props.drawerSlideDirection === 'sdLeft'){
   doMoveToRight();
   }else{
   doMoveToLeft();
   }

   return;
   }
   console.log(aniType);
   switch (aniType){
   case appTypes.PopupPanelAniType.FADE:
   case appTypes.PopupPanelAniType_Mobile.FADE:
   doFadeIn();
   break;
   case appTypes.PopupPanelAniType.ZOOM_IN:
   case appTypes.PopupPanelAniType_Mobile.ZOOM_IN:
   doZoomIn();
   break;
   case appTypes.PopupPanelAniType.NONE:
   case appTypes.PopupPanelAniType_Mobile.NONE:
   doShowOrigPoint();
   break;
   case appTypes.PopupPanelAniType_Mobile.MOVE_UP:
   doMoveToUp();
   break;
   case appTypes.PopupPanelAniType_Mobile.MOVE_DOWN:
   doMoveToDown();
   break;
   case appTypes.PopupPanelAniType_Mobile.MOVE_LEFT:
   doMoveToLeft();
   break;
   case appTypes.PopupPanelAniType_Mobile.MOVE_RIGHT:
   doMoveToRight();
   break;
   case appTypes.PopupPanelAniType_Mobile.EXPAND_DOWN:
   doExpandToDown();
   break;
   case appTypes.PopupPanelAniType_Mobile.EXPAND_RIGHT:
   doExpandToRight();
   break;
   case appTypes.PopupPanelAniType_Mobile.EXPAND_UP:
   doExpandToUp();
   break;
   case appTypes.PopupPanelAniType_Mobile.EXPAND_LEFT:
   doExpandToLeft();
   break;
   }
   }

   function builderOpenAnimateParams(){
   var positionPolicy = props.positionPolicy;

   contentCloseAnimateParams = contentOpenAnimateParams = contentOpenBeforeCSS = bgOpenAnimateParams = bgCloseAnimateParams = undefined;
   switch(positionPolicy){
   case appTypes.PositionPolicy.FREE:
   doLocationFree();
   break;
   case appTypes.PositionPolicy.SCREEN:
   doLocationToScreen();
   break;
   case appTypes.PositionPolicy.SOURCE_COM:
   doLocationToSourceCom();
   break;
   }
   if(props.isShowBackground) {
   doInitBgAnimate();
   }
   }

   function openAnimate(){
   if (self.popup.props.isShowBackground && self.popup.props.isFade) {
   self.background.animate({opacity:1});
   }
   if (openAnimateParams) {
   if(command.contentCommand.previourCSS){
   content.css(command.contentCommand.previourCSS);
   }
   content.animate(command.contentCommand.params, option);
   } else {
   content.css({opacity: 1});
   }
   }


   function doOpen(){
   builderOpenAnimateParams();
   console.log('==============================================================');
   console.log('contentOpenAnimateParams',contentOpenAnimateParams);
   console.log('contentCloseAnimateParams',contentCloseAnimateParams);
   console.log('contentOpenBeforeCSS',contentOpenBeforeCSS);
   console.log('bgOpenAnimateParams',bgOpenAnimateParams);
   console.log('bgCloseAnimateParams',bgCloseAnimateParams);
   }

   function doClose(){}

   */

  function closeAnimate(ani, callback) {
    var duration = 10;
    self.content.animate({opacity: 0}, {
      queue: false, duration: duration, complete: function () {
        callback(true);
      }
    });
    self.background.animate({opacity: 0}, {queue: false, duration: duration});
    $(self.dom).off(CLOSE_POPUP_EVENT);
    $(self.dom).off(OPEN_POPUP_EVENT);
    self.popup.isOpen = false;
    self.popup.popupManager = null;
    delete self.popup.popupManager;
    delete popupStack[props.controlID];
  }


  function startLoadInteractive() {
    if (self.popup) {
      if (self.popup.props) {
        if (self.popup.props.onOpened) {
          self.popup.props.onOpened(self.popup.props);
        }
      }
    }
  }

  function registerCloseFunction() {

    $(self.dom).off(CLOSE_POPUP_EVENT);
    $(self.dom).on(CLOSE_POPUP_EVENT, function (e, data) {
      var pageMouseX;
      var pageMouseY;
      var closePolicy = self.popup.props.closeByClickMode;
      var contentDom;
      var contentBounds;
      var comID;
      self.callback = undefined;
      if (data) {
        comID = data.controlID;
        if(comID === self.popup.props.controlID) {
          self.callback = data.callback;
          if (!_.isUndefined(data.mousePoint)) {
            pageMouseX = data.mousePoint.x;
            pageMouseY = data.mousePoint.y;
            if (closePolicy === appTypes.PopupPanelClosePolicy.ALL) {
              closeAnimate({}, afterClose);
            } else if (closePolicy === appTypes.PopupPanelClosePolicy.OUT_AREA) {
              contentDom = self.content[0];
              contentBounds = contentDom.getBoundingClientRect();
              if (!(pageMouseX > contentBounds.left && pageMouseX < contentBounds.right && pageMouseY > contentBounds.top && pageMouseY < contentBounds.bottom)) {
                closeAnimate({}, afterClose);
              } else {
                afterClose();
              }
            } else {
              afterClose();
            }
          } else {
            if (closePolicy !== appTypes.PopupPanelClosePolicy.NONE) {
              closeAnimate({}, afterClose);
            } else {
              afterClose(true);
            }
          }
        }
      }
    });
  }


  function onPopup() {
    startLoadInteractive();
  }

  function registerOpenFunction() {
    $(self.dom).off(OPEN_POPUP_EVENT);
    $(self.dom).on(OPEN_POPUP_EVENT, function () {
      if (self.popup.props.popupCommand) {
        if (self.popup.props.open) {
          self.popup.props.open($(self.dom), self.popup.props, self.content, self.background, onPopup);
        }
      }
    });
  }

  function registerScreenClick(){
    $(self.dom).off('onScreenClick');
    $(self.dom).on('onScreenClick',function(e,data){
      /*
      1、查找此处被点击的最上层组件
      2、如果找到，判断是否有链接跳转，如果有，不做弹出关闭动作
      3、如果不满足条件2时，判断源组件是否有交互，如果有，不关闭（可以考虑目标是否包含当前的弹出组件，如果不包含，则也执行4）
      4、如果3也不满足时，判断点击坐标是否在内容上，并根据条件判断是否关闭
       */


      //console.log(data)
    })
  }

  function afterClose(isRefresh) {
    if (self.callback) {
      self.callback(isRefresh ? props.controlID : undefined);
    }
  }

  popup.open = function () {
    if (self.popup.props.popupCommand) {
      $(self.dom).trigger(OPEN_POPUP_EVENT);
    }
  };

  function init() {
    $(self.dom).off(OPEN_POPUP_EVENT);
    $(self.dom).off(CLOSE_POPUP_EVENT);
  }

  this.popup = popup;
  popup.popupManager = this;
  init();
  registerCloseFunction();
  registerOpenFunction();
  registerScreenClick();
}


module.exports = {
  //注册一个弹出面板对象
  registerPopup: function (popup) {
    new RegisterPopup(popup, this);
  },

  init: function () {

  },


  //触发一个弹出面板的打开事件
  //之后改进时的参数必须包含data,
  //data中必须包含一个callback的回调函数
  OPEN_POPUP_EVENT: OPEN_POPUP_EVENT,
  //触发一个弹出面板的关闭事件，分发该事件时，有两个参数onClosePopup(e,data),
  // 其中data如果不为空时，
  // 可以包含 callback 的回调函数，它有一个参数CompID
  // 可以包含mousePoint的参数，该值为页面的鼠标坐标 ｛x,y｝
  CLOSE_POPUP_EVENT: CLOSE_POPUP_EVENT
};


// WEBPACK FOOTER //
// ./src/interactive/PopupHelper.js